import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'popup-close',
  templateUrl: './popup-close.component.html',
  styles: []
})
export class PopupCloseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
